import { useThemeColor } from '@/hooks/useThemeColor';

interface FormSectionTitleProps {
    title: string;
}

export default function FormSectionTitle({ title }: FormSectionTitleProps) {
    const { scheme } = useThemeColor();
    return (
        <div className="flex items-center space-x-2">
            <div className={`w-2 h-6 lg:h-8 ${scheme?.bg} ${scheme?.bgText}`} />
            <span className="font-corp font-bold text-sm lg:text-base text-color-base tracking-widest">{title}</span>
        </div>
    );
}
